import Main from "./map/Main";

import './App.css';
import './fonts/DINOT-Bold.otf';
import './fonts/DINOT-Medium.otf';
import './fonts/DINOT.otf';

function App() {
  return (
    <Main/>
  );
}

export default App;
